<template>
  <div>
    <header-img  :list="headerList"></header-img>
    <div class="main-block">
      <!-- <div class="top-title">项目详情</div> -->
      <header class="title">{{dataInfo.title}}</header>
      <section class="tip">
        <span>发布时间：{{dataInfo.publicTime}}</span>
        <!-- <span style="margin-left:20px;">来源：{{dataInfo.origin}}</span> -->
        <span style="margin-left:20px;">浏览量：{{dataInfo.pv}}</span>
      </section>

      <div class="container">
        <img class="cover" v-if="dataInfo.imgUrl" :src="dataInfo.imgUrl" />
        <div class="contentsss" v-html="dataInfo.content "></div>
      </div>
    </div>
  </div>
</template>
<script>
import HeaderImg from "@/components/HeaderImg";
export default {
  components: {
    HeaderImg,
  },
  data() {
    return {
      dataInfo: {},
      headerList: [
        { name: "产权交易中心", path: "/Home" },
        { name: "项目公告",path: "/ProjectAnnouncement"},
        { name: "项目详情"}
      ],
    };
  },
  methods: {
    getDetail(param) {
      this.$api.trade.getProjectDetail(param).then(res => {
        this.dataInfo = res.data;
      }).catch(err => {});
    }
  },
  mounted() {
    window.scrollTo(0, 0)
    this.getDetail(this.$route.query);
  }
};
</script>

<style lang="scss">
.contentsss {
  text-indent: 2em;
  overflow: hidden;
  img{
    display: block;
    margin: 10px auto;
    max-width: 100%;
  }
}
</style>
<style lang="scss" scoped>

  .title {
    color: #333;
    text-align: center;
    font-weight: bold;
    font-size: 20px;
    line-height: 60px;
  }
  .tip {
    color: #666;
    font-size: 14px;
    text-align: center;
  }
  .container {
    margin: 30px auto;
    font-size: 16px;
    .cover {
      max-width: 100%;
      overflow: hidden;
      display: block;
      margin: auto;
    }
  }

</style>